import { Icon } from "@iconify/react";
import PropTypes from "prop-types";
import { brand } from "../../../context";
import { NotificationBanner } from "../../banners/NotificationBanner";

export function QuotationChatApprovalModal({ onClose }: { onClose: () => void }) {
  return (
    <div className="Modal">
      <div className="Modal__card" data-brand={brand}>
        <div className="Modal__card__header" data-brand={brand}>
          Quotation Chat
          <Icon className="Modal__card__header__icon" icon="humbleicons:times" onClick={onClose} />
        </div>
        <div className="Modal__card__body">
          <NotificationBanner
            variant="warning"
            title="Account Not Approved"
            description="Your account is not approved yet. Please contact your account manager for further information."
            showCloseButton={false}
          />
        </div>
      </div>
    </div>
  );
}

QuotationChatApprovalModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};
